import { Page } from "../layout/page";
import { Accordion, Title } from "@mantine/core";
import React, { useState, useEffect } from "react";
import ReportDebitNote from "../components/reportDebitNote";
import { useTranslation } from "react-i18next";

import ReportGIRenewal from "../components/reportGIRenewal";
import ReportGIPendingRenewal from "../components/reportGIPendingRenewal";
import ReportGIOutstandingDocument from "../components/reportGIOutstandingDocument";
import ReportGIInsurerOutstandingSettlement from "../components/reportGIInsurerOutstandingSettlement";

const GIReport = ({}) => {
  const { t } = useTranslation();

  const reports = [
    {
      title: t("Debit Note Report"),
      reportComponent: ReportDebitNote,
    },
    {
      title: t("GI Renewal Report"),
      reportComponent: ReportGIRenewal,
    },

    {
      title: t("GI Pending Renew DN Report"),
      reportComponent: ReportGIPendingRenewal,
    },

    {
      title: t("GI OutStanding Document Report"),
      reportComponent: ReportGIOutstandingDocument,
    },
    {
      title: t("GI Insurer Outstanding Settlement Report"),
      reportComponent: ReportGIInsurerOutstandingSettlement,
    },
  ];

  return (
    <Page title={t("Report")}>
      <Accordion
        variant="separated"
        radius="xs"
        defaultValue="customization"
        mt={"xl"}
      >
        {reports.map((r) => (
          <Accordion.Item value={r.title}>
            <Accordion.Control>
              <Title order={5}>{t(r.title)}</Title>
            </Accordion.Control>
            <Accordion.Panel>
              <r.reportComponent />
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Page>
  );
};

export default GIReport;
